import Sentry from "@similarweb/sentry-logger";

export function safeJsonParse<T>(jsonString: string | undefined, defaultResponse: T, errorMessage?: string): T;
export function safeJsonParse<T>(jsonString?: string, defaultResponse?: T, errorMessage?: string): T | undefined;
export function safeJsonParse<T>(
    jsonString?: string,
    defaultResponse?: T,
    errorMessage = "error parsing JSON",
): T | undefined {
    // the string "undefined" is also not valid JSON grammar
    //https://datatracker.ietf.org/doc/html/rfc8259#section-2
    if (jsonString === undefined || jsonString === "undefined") {
        return defaultResponse;
    }
    try {
        const parsed = JSON.parse(jsonString) as T;
        return parsed ?? defaultResponse;
    } catch (e) {
        Sentry.error(errorMessage, e as Error);
        return defaultResponse;
    }
}
